export const TEMPO_TAGGED_REVIEWS = 'tempo_tagged_reviews';
export const HUB_REDIRECT = 'hub_redirect';
export const DORMANT_PAUSED_NO_SUBSCRIPTION = 'dormant_paused_no_subscription';
export const HNE_POST_SAVE_UPSELL = 'hne_post_save_upsell';
export const EXPRESSPLUS_SATURATION_DYNAMIC = 'expressplus_saturation_dynamic';
export const EXPRESSPLUS_SATURATION_STATIC = 'expressplus_saturation_static';
export const REORDERED_FUNNEL_CORE = 'reordered_funnel_core';
export const REORDERED_FUNNEL_FAMILY = 'reordered_funnel_family';
export const REORDERED_FUNNEL_TEMPO = 'reordered_funnel_tempo';
export const TEMPO_HNE_ON_CORE = 'tempo_hne_on_core';
export const THANK_YOU_PAGE_REDESIGN = '2026_09_redesigned_thankyou_page';
export const PREMIUM_SIDE_ANGLE_STATIC = 'premium_side_angle_static';
export const PREMIUM_SIDE_ANGLE_DYNAMIC = 'premium_side_angle_dynamic';
export const CORE_MENU_CONSOLIDATION = 'core_menu_consolidation';
export const CORE_MENU_CONSOLIDATION_HOME_ASSIGNMENT_KEY = 'coreMenuConsolidationHomeAssignment';
export const HNE_TRAY_IMAGE = 'hne_tray_image';
